import { createIcon } from '../shared'

const SaveIcon = createIcon(
  ({ color }) => (
    <path
      d="M5 21V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H17C17.55 3 18.0208 3.19583 18.4125 3.5875C18.8042 3.97917 19 4.45 19 5V21L12 18L5 21ZM7 17.95L12 15.8L17 17.95V5H7V17.95Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'SaveIcon',
)

export { SaveIcon }
